const questionaries = {
    Framinghan: 'CRC-0006',
};

export default questionaries;